module.exports = __webpack_public_path__ + "res/img/icon-excel.1abae77b.png";